import {useEffect, useState, useDebugValue} from 'react';

import {getLabels, handleLocale} from '../../../utils/translations';
import {useTranslations} from './useTranslations';


function useDefaultTranslations(props) {
    const {
        systemOptions: propsSystemOptions,
        translations: propsTranslations
    } = props;

    let {locale} = propsSystemOptions;

    locale = handleLocale(locale);

    const [labels, setlabels] = useState({});

    useEffect(() => {
        (async () => {
            const result = await getLabels(locale);
            setlabels(result);
        })();
    }, [locale]);

    const {
        translations
    } = useTranslations(labels, propsTranslations);

    const result = translations;

    useDebugValue(result);

    return result;
}

export {useDefaultTranslations};
